// extracted by mini-css-extract-plugin
export default {"credits":"credit_credits__3BCuq","wrapper":"credit_wrapper__O660d","retour":"credit_retour__QWvx7","links":"credit_links__UKeRG","neon-box-3":"credit_neon-box-3__o1mr2"};